// extracted by mini-css-extract-plugin
export default {"container":"Dropdown_container__Kq9Nw","hyperlink":"Dropdown_hyperlink__vnrSq","description":"Dropdown_description__cCxSB","divider":"Dropdown_divider__n3Vvb"};